<template>
  <div class="GroupInfo">
    <van-nav-bar title="群组" fixed border @click-left="onClickLeft">
      <template #left>
        <img src="../../assets/img/icon/left-arrow.png" class="icon" />
      </template>
    </van-nav-bar>
    <van-cell-group>
      <van-cell
        round
        v-for="item in groupInfo"
        :key="item+''"
        :title="item.ug_name"
        :value="item.group_user.length+'人'"
        @click="onClickGrouproom(item.ug_id, item.ug_name)"
      >
        <van-image
          width="30px"
          height="30px"
          round
          slot="icon"
          class="err-image-header"
          :src="attach_url+item.ug_icon"
          alt
        />
      </van-cell>
    </van-cell-group>
  </div>
</template>

<script>
export default {
  name: "GroupInfo",
  data() {
    return {
      u_id: "",
      token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
      groupInfo: [],
      attach_url: this.Conf.serverPre
    };
  },
  methods: {
    loadData() {
      var params = {
        u_id: this.u_id,
        token: this.token
      };
      var url = this.Conf.serverUrl + "Groups/getGroupInfoByUserID" + "?num="+Math.random();
      this.$axios
        .post(url, this.$qs.stringify(params))
        .then(response => {
          this.groupInfo = response.data.result[0].user_group;
        })
        .catch(error => {});
    },
    onClickLeft() {
      this.$router.push({
        name: "Friend",
        query: {
          active: 1
        }
      });
    },
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		},
    onClickGrouproom(ug_id, ug_name) {
      this.$router.push({
        name: "GroupChatroom",
        query: {
          ug_id: ug_id,
          ug_name: ug_name,
          url: "GroupInfo"
        }
      });
    }
  },
  created() {
		this.getStateConfigs();
    var params = this.$route.query;
    this.u_id = params.u_id;
    this.loadData();
  }
};
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Group/GroupInfo.vue